import { type ElementRef, forwardRef } from 'react';

import {
  Button,
  type ButtonProps as ButtonStyleProps,
} from '@backyard-ui/core';
import { Checkmark, HeartOutline } from '@backyard-ui/icons';

import { type ButtonProps } from '@/presenters/components/common/Wishlist/model';

type ButtonConfigProps = {
  text: string;
  icon: JSX.Element;
  variant: ButtonStyleProps['variant'];
};

const WishlistButton = forwardRef<ElementRef<typeof Button>, ButtonProps>(
  (props, ref) => {
    const { isInWishlist, ...rest } = props;

    const buttonConfig: ButtonConfigProps = isInWishlist
      ? {
          text: 'Adicionado aos favoritos',
          icon: <Checkmark />,
          variant: 'solid',
        }
      : {
          text: 'Lista de favoritos',
          icon: <HeartOutline />,
          variant: 'outline',
        };

    return (
      <Button
        size="sm"
        variant={buttonConfig.variant}
        iconLeft={buttonConfig.icon}
        ref={ref}
        {...rest}
      >
        {buttonConfig.text}
      </Button>
    );
  }
);

WishlistButton.displayName = 'WishlistButton';

export default WishlistButton;
